export default __webpack_public_path__ + "static/media/team104.61a5d33a.JPG";